module.exports = __webpack_public_path__ + "img/quill_info.b06be55e.svg";